module.exports = __webpack_public_path__ + "assets/4a3deb33e1629318d701dd346872811e.png";